/** @module csi/datasheet/CanvasTemplateForm */
define([
	"dojo/_base/declare",
	"csi/api",
	"csi/config",
	"csi/form/Widget",
	"csi/html",
	"csi/sessionConstants",
	"csi/xml"
], function(declare,api,config,Widget,html,sessionConstants,xml) {

	var CANVAS_NOTES_ORIENTATION = "CanvasNotesOrientation";
	var NOTES_ORIENTATION = "NotesOrientation";
	var PAPER_ORIENTATION = "PaperOrientation";
	var PAPER_SIZE = "PaperSize";
	var SPECIFICATION_DATA_SHEET = "SpecificationDataSheet";
	var DATASHEET_SUBTYPE = "DatasheetSubtype";
	var DATASHEET_TYPE = "DatasheetType";

	return declare(Widget, {
		_resolveView: function() {
			this.inherited(arguments);

			var sitePaperSize = sessionConstants.sitePaperSize;
			var sitePaperOrientation = sessionConstants.sitePaperOrientation;
			var notesOrientation = (sitePaperOrientation === api.LANDSCAPE) ? html.LEFT : html.TOP;

			this.addDefaultValue(PAPER_SIZE, xml.enumCreate(PAPER_SIZE, sitePaperSize));
			this.addDefaultValue(PAPER_ORIENTATION, xml.enumCreate(PAPER_ORIENTATION, sitePaperOrientation));
			this.addDefaultValue(NOTES_ORIENTATION, xml.enumCreate(CANVAS_NOTES_ORIENTATION, notesOrientation));

			var field = this.defView.getField(DATASHEET_TYPE);
			console.assert(!!field);

			if (this.isCopy()) {
				this.setFieldDisabled(DATASHEET_TYPE, true);
				this.setFieldDisabled(DATASHEET_SUBTYPE, true);
				this.setFieldDisabled(PAPER_SIZE, true);
				this.setFieldDisabled(PAPER_ORIENTATION, true);
				this.setFieldDisabled(NOTES_ORIENTATION, true);
			}
		},

		/**
		 * Only show SpecificationDataSheetSubtype field if canvas template type is SpecificationDataSheet.
		 */
		_updateFieldVisibility: function(field) {
			var canvasType = xml.enumGetText(this.getFieldValue(DATASHEET_TYPE));
			var hideSubType = (canvasType !== SPECIFICATION_DATA_SHEET);
			this.setFieldHidden(DATASHEET_SUBTYPE, hideSubType);
		},

		/**
		 * Creates the store for the DatasheetSubtype field
		 * @param {Field} field
		 * @param {String} value
		 */
		getFieldStore: function(field, value) {
			if (field.m_id == DATASHEET_SUBTYPE) {
				return config.getSubtypeStore(SPECIFICATION_DATA_SHEET);
			} else {
				return this.inherited(arguments);
			}
		},

		/**
		 * Set the notes orientation based on the page orientation.
		 */
		onChangeField: function(/*Field*/field) {
			this.inherited(arguments);

			if (field.m_name == PAPER_ORIENTATION && this.getField(NOTES_ORIENTATION).isDefaultValue()) {
				var paperOrientation = xml.enumGetText(field.getValue());
				var notesOrientation = (paperOrientation === api.LANDSCAPE) ? html.LEFT : html.TOP;
				this.setFieldValue(NOTES_ORIENTATION, xml.enumCreate(CANVAS_NOTES_ORIENTATION, notesOrientation));
			} else if (field.m_name == DATASHEET_TYPE) {
				this.setFieldValue(DATASHEET_SUBTYPE, "");
			}
		}
	});
});
